var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "d-flex flex-column justify-center align-sm-center height-100x overflow-auto width-100",
    },
    [
      _c(
        "div",
        {
          staticClass: "height-100x py-10",
          staticStyle: { "max-width": "800px" },
        },
        [
          _c("div", { staticClass: "text-center mb-2 p-relative" }, [
            _c("div", [
              _c(
                "svg",
                {
                  attrs: {
                    width: "80",
                    viewBox: "0 0 109 122",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M1.19357 23.8239C-0.00582433 50.0569 5.19157 98.7753 55.8329 121.528C89.1495 106.538 102.743 80.439 107.94 56.749C59.9641 30.7836 1.32684 23.8239 1.19357 23.8239ZM55.1665 96.5C30.3789 85.3911 27.8469 61.5673 28.5132 48.7184C28.5132 48.7184 57.1655 52.1983 80.6204 64.9133C78.0884 76.4237 71.425 89.2725 55.1665 96.5Z",
                      fill: "#303031",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M105.941 11.1089C91.2817 2.40915 53.434 0 53.434 0C53.434 0 15.5863 2.40915 0.793701 11.1089C0.793701 11.1089 67.2937 18.604 107.94 42.0264C108.873 24.2254 105.941 11.1089 105.941 11.1089Z",
                      fill: "#F9B41C",
                    },
                  }),
                ]
              ),
            ]),
            _c("div", [
              _c(
                "svg",
                {
                  attrs: {
                    width: "100",
                    viewBox: "0 0 133 62",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M6.92986 50.6234H2.13226V52.8988H6.66333V54.6387H2.13226V59.1893H0V48.7497H6.92986V50.6234Z",
                      fill: "#303031",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M14.9258 55.4418C14.9258 57.9848 13.3266 59.457 11.0611 59.457C8.66226 59.457 7.32959 57.5832 7.32959 55.4418C7.32959 52.7649 9.06205 51.4265 11.0611 51.4265C13.1933 51.4265 14.9258 52.7649 14.9258 55.4418ZM9.32859 55.4418C9.32859 56.5125 9.99492 57.8509 11.0611 57.8509C12.2605 57.8509 12.7935 56.6463 12.7935 55.4418C12.7935 54.2372 12.2605 53.0326 11.0611 53.0326C10.1282 53.0326 9.32859 53.9695 9.32859 55.4418Z",
                      fill: "#303031",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M18.2575 52.4972C18.6573 51.828 19.5902 51.4265 20.3898 51.4265C20.523 51.4265 20.9228 51.4265 21.0561 51.4265V53.3003C20.9228 53.3003 20.523 53.3003 20.3898 53.3003C19.4569 53.3003 18.2575 53.8356 18.2575 54.9064V59.1893H16.1252V51.5603H18.1242L18.2575 52.4972Z",
                      fill: "#303031",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M33.983 59.1893H26.6533V48.7497H33.7164V50.4896H28.7856V52.7649H33.4499V54.5049H28.7856V57.1817H33.8497V59.1893H33.983Z",
                      fill: "#303031",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M37.4478 55.4418L34.7825 51.6942H37.1813L38.6472 53.7018L40.1131 51.5603H42.5119L39.8466 55.4418L42.5119 59.1893H40.1131L38.6472 57.0479L37.1813 59.1893H34.7825L37.4478 55.4418Z",
                      fill: "#303031",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M50.9078 55.4418C50.9078 57.9848 49.5751 59.457 47.5761 59.457C46.6432 59.457 45.9769 59.0555 45.5771 58.5201V62.1339H43.4448V51.6942H45.4438L45.5771 52.6311C45.9769 51.9619 46.6432 51.5603 47.5761 51.5603C49.5751 51.4265 50.9078 53.1664 50.9078 55.4418ZM45.5771 55.1741V55.8433C45.7104 57.0479 46.1102 57.8509 47.1763 57.8509C48.2424 57.8509 48.7755 56.5125 48.7755 55.4418C48.7755 54.1033 48.2424 53.0326 47.1763 53.0326C46.2434 53.0326 45.5771 53.9695 45.5771 55.1741Z",
                      fill: "#303031",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M52.2407 48.6158H54.373V59.1893H52.2407V48.6158Z",
                      fill: "#303031",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M63.3018 55.4418C63.3018 57.9848 61.7026 59.457 59.437 59.457C57.0382 59.457 55.7056 57.5832 55.7056 55.4418C55.7056 52.7649 57.438 51.4265 59.437 51.4265C61.5693 51.4265 63.3018 52.7649 63.3018 55.4418ZM57.7046 55.4418C57.7046 56.5125 58.3709 57.8509 59.437 57.8509C60.6364 57.8509 61.1695 56.6463 61.1695 55.4418C61.1695 54.2372 60.6364 53.0326 59.437 53.0326C58.5042 53.0326 57.7046 53.9695 57.7046 55.4418Z",
                      fill: "#303031",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M68.7653 53.7018C68.2323 53.3003 67.4327 53.0326 67.1661 53.0326C66.7663 53.0326 66.3665 53.1664 66.3665 53.568C66.3665 53.9695 66.8996 54.2372 67.6992 54.6387C68.8986 55.3079 69.9647 55.8433 69.9647 57.0479C69.9647 58.9216 68.3655 59.457 67.0329 59.457C65.9667 59.457 64.7673 59.0555 63.8345 58.1186L65.0339 56.7802C65.5669 57.3155 66.4998 57.8509 67.0329 57.8509C67.5659 57.8509 67.8325 57.5832 67.8325 57.3155C67.8325 56.914 67.2994 56.6463 66.6331 56.2448C65.5669 55.7094 64.2343 55.0402 64.2343 53.8357C64.2343 52.0957 65.8335 51.4265 67.0329 51.4265C67.9657 51.4265 69.0319 51.828 69.6982 52.3634L68.7653 53.7018Z",
                      fill: "#303031",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M71.0312 48.6158H73.5633V50.6234H71.0312V48.6158ZM71.1645 51.5603H73.2968V59.1893H71.1645V51.5603Z",
                      fill: "#303031",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M82.2256 55.4418C82.2256 57.9848 80.6264 59.457 78.3609 59.457C75.9621 59.457 74.6294 57.5832 74.6294 55.4418C74.6294 52.7649 76.3619 51.4265 78.3609 51.4265C80.6264 51.4265 82.2256 52.7649 82.2256 55.4418ZM76.7617 55.4418C76.7617 56.5125 77.428 57.8509 78.4941 57.8509C79.6935 57.8509 80.2266 56.6463 80.2266 55.4418C80.2266 54.2372 79.6935 53.0326 78.4941 53.0326C77.5613 53.0326 76.7617 53.9695 76.7617 55.4418Z",
                      fill: "#303031",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M85.6904 52.4972C86.2235 51.828 87.1563 51.4265 87.6894 51.4265C89.4219 51.4265 90.7545 52.4972 90.7545 54.5049V59.3232H88.6223V54.7725C88.6223 53.8357 87.9559 53.1664 87.4229 53.1664C86.3567 53.1664 85.8237 53.9695 85.8237 54.9064V59.1893H83.6914V51.5603H85.5571L85.6904 52.4972Z",
                      fill: "#303031",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M100.616 48.8835C102.748 48.8835 104.348 50.2219 104.348 52.2295C104.348 54.2372 102.748 55.5756 100.616 55.5756H99.017V59.1893H96.8848V48.7497H100.616V48.8835ZM98.8838 50.6234V53.8357H100.616C101.549 53.8357 102.082 53.1664 102.082 52.2295C102.082 51.2926 101.416 50.6234 100.616 50.6234H98.8838Z",
                      fill: "#303031",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M107.812 52.4972C108.212 51.828 109.145 51.4265 109.945 51.4265C110.078 51.4265 110.478 51.4265 110.611 51.4265V53.3003C110.478 53.3003 110.078 53.3003 109.945 53.3003C109.012 53.3003 107.812 53.8356 107.812 54.9064V59.1893H105.68V51.5603H107.679L107.812 52.4972Z",
                      fill: "#303031",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M118.607 55.4418C118.607 57.9848 117.008 59.457 114.743 59.457C112.344 59.457 111.011 57.5832 111.011 55.4418C111.011 52.7649 112.744 51.4265 114.743 51.4265C117.008 51.4265 118.607 52.7649 118.607 55.4418ZM113.01 55.4418C113.01 56.5125 113.677 57.8509 114.743 57.8509C115.942 57.8509 116.475 56.6463 116.475 55.4418C116.475 54.2372 115.942 53.0326 114.743 53.0326C113.943 53.0326 113.01 53.9695 113.01 55.4418Z",
                      fill: "#303031",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M127.003 55.4418C127.003 57.9848 125.404 59.457 123.138 59.457C120.739 59.457 119.407 57.5832 119.407 55.4418C119.407 52.7649 121.139 51.4265 123.138 51.4265C125.404 51.4265 127.003 52.7649 127.003 55.4418ZM121.406 55.4418C121.406 56.5125 122.072 57.8509 123.138 57.8509C124.338 57.8509 124.871 56.6463 124.871 55.4418C124.871 54.2372 124.338 53.0326 123.138 53.0326C122.339 53.0326 121.406 53.9695 121.406 55.4418Z",
                      fill: "#303031",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M128.736 51.5603V51.025C128.736 50.6234 128.736 50.0881 128.869 49.8204C129.269 48.7497 130.202 48.3481 131.134 48.3481C131.668 48.3481 132.334 48.482 133.133 48.7497L132.467 50.3558C131.934 50.0881 131.534 50.0881 131.401 50.0881C131.268 50.0881 131.134 50.2219 131.001 50.3558C131.001 50.4896 131.001 50.6234 131.001 51.025V51.5603H132.467V53.3003H131.001V59.1893H128.869V53.3003H127.936V51.5603H128.736Z",
                      fill: "#303031",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M7.86273 8.59708V18.9029H22.2555V26.2642H7.86273V42.7268H0V1.23578H26.2535V8.59708H7.86273Z",
                      fill: "#303031",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M47.976 0.432739C59.3037 0.432739 67.1664 8.32942 67.1664 21.9813C67.1664 35.767 59.3037 43.5298 47.976 43.5298C36.6484 43.5298 28.7856 35.767 28.7856 21.9813C28.7856 8.19558 36.6484 0.432739 47.976 0.432739ZM47.976 36.0347C54.6393 36.0347 59.3037 31.3502 59.3037 21.9813C59.3037 12.6124 54.6393 7.92789 47.976 7.92789C41.3127 7.92789 36.6484 12.6124 36.6484 21.9813C36.6484 31.3502 41.3127 36.0347 47.976 36.0347Z",
                      fill: "#303031",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M72.2305 1.23578H98.8838V8.59708H80.0932V17.6983H94.2194V25.0596H80.0932V35.3655H99.1503V42.7268H72.2305V1.23578Z",
                      fill: "#303031",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M120.473 36.5701C118.341 33.224 117.408 31.0825 117.274 31.0825C117.274 31.0825 116.208 33.0902 114.209 36.5701L110.611 42.7268H102.349L112.743 25.7289L103.281 9.534H111.944L115.009 15.1554C117.141 18.7691 118.074 20.7767 118.074 20.7767C118.074 20.7767 119.273 18.7691 121.272 15.0215L124.204 9.534H132.067L122.605 25.9966L133.133 42.7268H124.338L120.473 36.5701Z",
                      fill: "#303031",
                    },
                  }),
                ]
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "p-relative" },
            [
              _c("base-form", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ invalid }) {
                      return [
                        _c(
                          "h1",
                          {
                            staticStyle: {
                              "padding-bottom": "3%",
                              "text-align": "left",
                            },
                          },
                          [_vm._v(_vm._s("Signup Admin"))]
                        ),
                        _c(
                          "v-card",
                          { staticClass: "mb-5", attrs: { flat: "" } },
                          [
                            _c(
                              "v-card-text",
                              [
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(
                                          "v-radio-group",
                                          {
                                            attrs: { row: "" },
                                            on: {
                                              change:
                                                _vm.handleSignupModeChange,
                                            },
                                            model: {
                                              value: _vm.signupMode,
                                              callback: function ($$v) {
                                                _vm.signupMode = $$v
                                              },
                                              expression: "signupMode",
                                            },
                                          },
                                          [
                                            _c("v-radio", {
                                              attrs: {
                                                label: "Use Invitation Code",
                                                value: "invitation",
                                              },
                                            }),
                                            _c("v-radio", {
                                              attrs: {
                                                label:
                                                  "Create My Company Account",
                                                value: "own",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.isInvitationMode
                                  ? _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "6" } },
                                          [
                                            _c("base-text-field", {
                                              attrs: {
                                                value:
                                                  _vm.signupData.invitationCode,
                                                rules: "required",
                                                name: "invitationCode",
                                                label: "Invitation ID",
                                                disabled: _vm.isValidInvitation,
                                              },
                                              on: {
                                                "update:value": function (
                                                  $event
                                                ) {
                                                  return _vm.$set(
                                                    _vm.signupData,
                                                    "invitationCode",
                                                    $event
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "6" } },
                                          [
                                            _c(
                                              "base-btn",
                                              {
                                                attrs: {
                                                  color: "secondary",
                                                  disabled:
                                                    !_vm.signupData
                                                      .invitationCode,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.checkInvitationId()
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      "Check Invitation ID"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.isOwnAccount
                                  ? _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "6" } },
                                          [
                                            _c("base-text-field", {
                                              attrs: {
                                                value:
                                                  _vm.signupData.accountTitle,
                                                rules: "required",
                                                name: "accountTitle",
                                                label: "Account/Company Title",
                                              },
                                              on: {
                                                "update:value": function (
                                                  $event
                                                ) {
                                                  return _vm.$set(
                                                    _vm.signupData,
                                                    "accountTitle",
                                                    $event
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "6" } },
                                          [
                                            _c("base-text-field", {
                                              attrs: {
                                                value:
                                                  _vm.signupData.accountType,
                                                name: "accountType",
                                                label: "Account Type",
                                              },
                                              on: {
                                                "update:value": function (
                                                  $event
                                                ) {
                                                  return _vm.$set(
                                                    _vm.signupData,
                                                    "accountType",
                                                    $event
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "p-relative",
                                        attrs: { cols: "12" },
                                      },
                                      [
                                        _c("v-overlay", {
                                          attrs: {
                                            absolute: "",
                                            value:
                                              _vm.isInvitationMode &&
                                              !_vm.isValidInvitation,
                                          },
                                        }),
                                        _c(
                                          "v-row",
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "12" } },
                                              [_c("v-divider")],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-row",
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "6" } },
                                              [
                                                _c("base-text-field", {
                                                  attrs: {
                                                    value: _vm.signupData.email,
                                                    rules: "required|email",
                                                    name: "email",
                                                    disabled:
                                                      _vm.invitation &&
                                                      !!_vm.signupData.email,
                                                    label: "Login ID",
                                                  },
                                                  on: {
                                                    "update:value": function (
                                                      $event
                                                    ) {
                                                      return _vm.$set(
                                                        _vm.signupData,
                                                        "email",
                                                        $event
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c("v-col", {
                                              attrs: { cols: "6" },
                                            }),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "6" } },
                                              [
                                                _c("base-text-field", {
                                                  attrs: {
                                                    value:
                                                      _vm.signupData.password,
                                                    rules: "required",
                                                    name: "password",
                                                    label: "Password",
                                                    type: "password",
                                                    vid: "Password",
                                                  },
                                                  on: {
                                                    "update:value": function (
                                                      $event
                                                    ) {
                                                      return _vm.$set(
                                                        _vm.signupData,
                                                        "password",
                                                        $event
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "6" } },
                                              [
                                                _c("base-text-field", {
                                                  attrs: {
                                                    value:
                                                      _vm.signupData
                                                        .confirmPassword,
                                                    name: "confirmPassword",
                                                    label: "Confirm Password",
                                                    type: "password",
                                                    rules:
                                                      "required|confirmed:Password",
                                                  },
                                                  on: {
                                                    "update:value": function (
                                                      $event
                                                    ) {
                                                      return _vm.$set(
                                                        _vm.signupData,
                                                        "confirmPassword",
                                                        $event
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-row",
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "12" } },
                                              [_c("v-divider")],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-row",
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "6" } },
                                              [
                                                _c("base-text-field", {
                                                  attrs: {
                                                    value:
                                                      _vm.signupData.firstName,
                                                    name: "firstName",
                                                    label: "First Name",
                                                    rules:
                                                      "required|alphabetic",
                                                  },
                                                  on: {
                                                    "update:value": function (
                                                      $event
                                                    ) {
                                                      return _vm.$set(
                                                        _vm.signupData,
                                                        "firstName",
                                                        $event
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "6" } },
                                              [
                                                _c("base-text-field", {
                                                  attrs: {
                                                    value:
                                                      _vm.signupData.middleName,
                                                    name: "middleName",
                                                    rules: "alphabetic",
                                                    label: "Middle Name",
                                                  },
                                                  on: {
                                                    "update:value": function (
                                                      $event
                                                    ) {
                                                      return _vm.$set(
                                                        _vm.signupData,
                                                        "middleName",
                                                        $event
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "6" } },
                                              [
                                                _c("base-text-field", {
                                                  attrs: {
                                                    value:
                                                      _vm.signupData.lastName,
                                                    name: "middleName",
                                                    label: "Last Name",
                                                    rules:
                                                      "required|alphabetic",
                                                  },
                                                  on: {
                                                    "update:value": function (
                                                      $event
                                                    ) {
                                                      return _vm.$set(
                                                        _vm.signupData,
                                                        "lastName",
                                                        $event
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "6" } },
                                              [
                                                _c(
                                                  "PhoneNumberInputComponent",
                                                  {
                                                    attrs: {
                                                      value:
                                                        _vm.signupData
                                                          .workPhone,
                                                      name: "workPhone",
                                                      label: "Work Phone",
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.signupData,
                                                          "workPhone",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "6" } },
                                              [
                                                _c(
                                                  "PhoneNumberInputComponent",
                                                  {
                                                    attrs: {
                                                      value:
                                                        _vm.signupData
                                                          .mobilePhone,
                                                      name: "mobilePhone",
                                                      rules: "required",
                                                      label: "Mobile Phone",
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.signupData,
                                                          "mobilePhone",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-caption mt-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " By providing your mobile number, you consent to receive FOEX transactional SMS for account verification and account security. Message frequency varies. Message and data rates may apply. Reply STOP to opt out. "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-caption mt-1",
                                                  },
                                                  [
                                                    _vm._v(" Terms: "),
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.termsPolicyUrl,
                                                          target: "_blank",
                                                          rel: "noopener noreferrer",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Terms and Conditions"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-caption",
                                                  },
                                                  [
                                                    _vm._v(" Privacy: "),
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.privacyPolicyUrl,
                                                          target: "_blank",
                                                          rel: "noopener noreferrer",
                                                        },
                                                      },
                                                      [_vm._v("Privacy Policy")]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-row",
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "12" } },
                                              [_c("v-divider")],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-row",
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-caption mb-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " SMS use case: FOEX sends transactional messages for account signup verification (OTP), sign-in security checks, and critical service notifications related to account access. "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-caption mb-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " This workflow supports industrial safety operations only and does not include prohibited content categories. "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-caption mb-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Opt-in workflow: (1) user enters mobile number, (2) user explicitly checks SMS consent, (3) user submits signup, and (4) user confirms ownership by entering the OTP code. "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-caption mb-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Message frequency varies by account activity. Message and data rates may apply. Reply STOP to opt out at any time. "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-caption mb-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Customer care: contact ghkang@foex.kr / +82-55-293-0251."
                                                    ),
                                                  ]
                                                ),
                                                _c("base-checkbox", {
                                                  attrs: {
                                                    label:
                                                      "I agree to receive FOEX transactional SMS for account verification and account security notifications.",
                                                    inputValue:
                                                      _vm.smsOptInConsent,
                                                  },
                                                  on: {
                                                    "update:inputValue":
                                                      function ($event) {
                                                        _vm.smsOptInConsent =
                                                          $event
                                                      },
                                                    "update:input-value":
                                                      function ($event) {
                                                        _vm.smsOptInConsent =
                                                          $event
                                                      },
                                                  },
                                                }),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-caption mt-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " By opting in, you acknowledge the "
                                                    ),
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.termsPolicyUrl,
                                                          target: "_blank",
                                                          rel: "noopener noreferrer",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Terms and Conditions"
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" and "),
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.privacyPolicyUrl,
                                                          target: "_blank",
                                                          rel: "noopener noreferrer",
                                                        },
                                                      },
                                                      [_vm._v("Privacy Policy")]
                                                    ),
                                                    _vm._v(". "),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-row",
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "12" } },
                                              [_c("v-divider")],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm.isOwnAccount
                                          ? _c(
                                              "v-row",
                                              [
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "d-flex",
                                                    attrs: { cols: "6" },
                                                  },
                                                  [
                                                    _c("base-combobox", {
                                                      staticClass:
                                                        "flex-grow-1",
                                                      attrs: {
                                                        label: "Payment Method",
                                                        name: "paymentMethod",
                                                        items:
                                                          _vm.paymentMethods,
                                                        "item-text": "value",
                                                        "item-value": "key",
                                                        rules: "required",
                                                        clearable: "",
                                                        multiple: false,
                                                        "return-object": false,
                                                        value:
                                                          _vm.signupData
                                                            .paymentMethod,
                                                      },
                                                      on: {
                                                        "update:value":
                                                          function ($event) {
                                                            return _vm.$set(
                                                              _vm.signupData,
                                                              "paymentMethod",
                                                              $event
                                                            )
                                                          },
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "6" } },
                                                  [
                                                    _c("base-select", {
                                                      staticClass:
                                                        "flex-grow-1",
                                                      attrs: {
                                                        rules: "required",
                                                        name: "role",
                                                        items: _vm.periods,
                                                        clearable: "",
                                                        "item-text": "value",
                                                        "item-value": "key",
                                                        multiple: false,
                                                        "return-object": false,
                                                        value:
                                                          _vm.signupData.period,
                                                        label: "Period",
                                                      },
                                                      on: {
                                                        "update:value":
                                                          function ($event) {
                                                            return _vm.$set(
                                                              _vm.signupData,
                                                              "period",
                                                              $event
                                                            )
                                                          },
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "v-row",
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c("base-checkbox", {
                                                  attrs: {
                                                    label:
                                                      "I agree to the Terms and Conditions and Privacy Policy.",
                                                    inputValue:
                                                      _vm.signupData
                                                        .termsAndConditions,
                                                  },
                                                  on: {
                                                    "update:inputValue":
                                                      function ($event) {
                                                        return _vm.$set(
                                                          _vm.signupData,
                                                          "termsAndConditions",
                                                          $event
                                                        )
                                                      },
                                                    "update:input-value":
                                                      function ($event) {
                                                        return _vm.$set(
                                                          _vm.signupData,
                                                          "termsAndConditions",
                                                          $event
                                                        )
                                                      },
                                                  },
                                                }),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-caption mt-1",
                                                  },
                                                  [
                                                    _vm._v(" View documents: "),
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.termsPolicyUrl,
                                                          target: "_blank",
                                                          rel: "noopener noreferrer",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Terms and Conditions"
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" | "),
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.privacyPolicyUrl,
                                                          target: "_blank",
                                                          rel: "noopener noreferrer",
                                                        },
                                                      },
                                                      [_vm._v("Privacy Policy")]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "input-group mb-7",
                            staticStyle: { "text-align": "center" },
                          },
                          [
                            _c(
                              "base-btn",
                              {
                                staticClass: "mr-5",
                                attrs: { outlined: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openConsultationDialog()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s("Request Consultation") + " "
                                ),
                              ]
                            ),
                            _c(
                              "base-btn",
                              {
                                attrs: {
                                  disabled:
                                    invalid ||
                                    !_vm.signupData.termsAndConditions ||
                                    !_vm.smsOptInConsent ||
                                    (_vm.isInvitationMode &&
                                      !_vm.isValidInvitation),
                                  color: "rgb(115, 141, 202)",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.signup()
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s("Signup") + " ")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "input-group",
                            staticStyle: { "text-align": "center" },
                          },
                          [
                            _vm._v(
                              " " + _vm._s("Already have an account") + " "
                            ),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  to: { name: "signin" },
                                  link: "",
                                  text: "",
                                },
                              },
                              [_vm._v(" " + _vm._s("Signin") + " ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "base-dialog",
        {
          attrs: {
            name: _vm.consultationDialogName,
            "max-width": "520px",
            scrollable: false,
          },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [_vm._v(" " + _vm._s("Request Consultation") + " ")]
              },
              proxy: true,
            },
            {
              key: "dialogFooter",
              fn: function () {
                return [
                  _c(
                    "base-btn",
                    {
                      staticClass: "white--text",
                      attrs: { color: "grey lighten-1", depressed: "" },
                      on: {
                        click: function ($event) {
                          return _vm.closeConsultationDialog()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("Common.Close")) + " ")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "py-2" }, [
            _c(
              "div",
              { staticClass: "text-subtitle-1 font-weight-medium mb-3" },
              [_vm._v("You need to contact Foex via KakaoTalk or other means.")]
            ),
            _c("div", [
              _c("strong", [
                _vm._v(_vm._s(_vm.$t("Footer.contact.addressLabel"))),
              ]),
              _vm._v(" " + _vm._s(_vm.$t("Footer.contact.addressValue"))),
              _c("br"),
              _c("strong", [_vm._v(_vm._s(_vm.$t("Footer.contact.telLabel")))]),
              _vm._v(" " + _vm._s(_vm.$t("Footer.contact.telValue"))),
              _c("br"),
              _c("strong", [
                _vm._v(_vm._s(_vm.$t("Footer.contact.emailLabel"))),
              ]),
              _c(
                "a",
                { attrs: { target: "__blank", href: "mailto:ghkang@foex.kr" } },
                [_vm._v("   ghkang@foex.kr")]
              ),
              _c("br"),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }